/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface TypeFinancementSearch
 */
export interface TypeFinancementSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof TypeFinancementSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof TypeFinancementSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof TypeFinancementSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof TypeFinancementSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof TypeFinancementSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof TypeFinancementSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TypeFinancementSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TypeFinancementSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TypeFinancementSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the TypeFinancementSearch interface.
 */
export function instanceOfTypeFinancementSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TypeFinancementSearchFromJSON(json: any): TypeFinancementSearch {
    return TypeFinancementSearchFromJSONTyped(json, false);
}

export function TypeFinancementSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): TypeFinancementSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function TypeFinancementSearchToJSON(value?: TypeFinancementSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'libelle': TextSearchToJSON(value.libelle),
        'code': TextSearchToJSON(value.code),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

